// Constants for baby menu generation
export const EXCLUDED_PRODUCTS = [
  // Hygiene and cleaning
  'dentifrico', 'higiene', 'limpieza', 'detergente', 'suavizante',
  'ambientador', 'cosmetica', 'maquillaje', 'cera', 'toallitas',
  'pañal', 'crema', 'colonia', 'gel', 'champu', 'bandas de cera',
  'coloración permanente', 'tinte', 'deliplus', 'cepillo', 'fregona',
  
  // Pet products
  'perro', 'gato', 'mascota', 'junior', 'pienso', 'comida para perros',
  'comida para gatos', 'snack perro', 'snack gato',
  
  // Sweets and chocolates
  'chocolate', 'bombón', 'bombones', 'cacao', 'dulces',
  
  // Adult products
  'alcohol', 'cerveza', 'vino', 'licor', 'café', 'té',
  
  // Other non-food items
  'mascarilla', 'esponja', 'papel', 'bolsa',
  'venda', 'vendaje', 'apósito', 'gasa',
  
  // Kitchen items
  'cuchillo', 'palillo',
  
  // Snacks and processed foods
  'patatas fritas', 'copos de', 'cereales copos'
];

export const ALLOWED_FOODS = {
  '4-6': {
    fruits: ['manzana', 'pera', 'plátano'],
    vegetables: ['zanahoria', 'calabaza', 'patata'],
    cereals: ['cereales sin gluten', 'arroz']
  },
  '6-8': {
    fruits: ['manzana', 'pera', 'plátano', 'melocotón'],
    vegetables: ['zanahoria', 'calabaza', 'patata', 'calabacín'],
    cereals: ['cereales', 'arroz'],
    proteins: ['pollo']
  },
  '8-12': {
    fruits: ['todas'],
    vegetables: ['todas'],
    cereals: ['cereales', 'arroz', 'pasta'],
    proteins: ['pollo', 'pescado blanco', 'merluza', 'lenguado']
  },
  '12+': {
    fruits: ['todas'],
    vegetables: ['todas'],
    cereals: ['todas'],
    proteins: ['pollo', 'pavo', 'pescado blanco', 'merluza', 'lenguado']
  }
};

export const AGE_RANGE_DESCRIPTIONS = {
  '4-6': 'Introducción de primeros alimentos sólidos',
  '6-8': 'Ampliación de la variedad de alimentos',
  '8-12': 'Texturas más consistentes',
  '12+': 'Transición a alimentación familiar'
} as const;